import React, { useState } from 'react';
import { Container, Form, InputGroup } from 'react-bootstrap';
import { AiOutlineMail, AiOutlineUnlock, AiOutlineUser } from 'react-icons/ai';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { clearErrors, login, register } from '../../redux/actions/userAction';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';
import Loader from '../common/Loader';

const RegisterLogin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, isAuthenticated, error, user } = useSelector((state) => state.user);
    const [activeTab, setActiveTab] = useState('LOGIN');
    const [loginDetails, setLoginDetails] = useState({
        email: '',
        password: '',
    });
    const [registerDetails, setRegisterDetails] = useState({
        name: '',
        email: '',
        password: '',
        avatar: '',
    });
    const [avatarPreview, setAvatarPreview] = useState('/assets/images/user.svg');
    const [avatar, setAvatar] = useState('');
    const location = useLocation();

    const redirect = location.search ? location.search.split('=')[1] : 'account';

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (isAuthenticated) {
            navigate(`/${redirect}`);
        }
    }, [isAuthenticated, error]);

    const handleLoginSubmit = (e) => {
        e.preventDefault();
        dispatch(login(loginDetails));
    };

    const handleRegisterSubmit = (e) => {
        e.preventDefault();
        dispatch(register({ ...registerDetails, avatar: avatar }));
    };

    const handleLoginDataChange = (e) => {
        setLoginDetails({ ...loginDetails, [e.target.name]: e.target.value });
    };

    const handleRegisterDataChange = (e) => {
        if (e.target.name === 'avatar') {
            if (e.target.value === '') {
                return;
            }
            const reader = new FileReader();

            reader.onload = (e) => {
                if (reader.readyState === 2) {
                    setAvatarPreview(reader.result);
                    setAvatar(reader.result);
                }
            };

            reader.readAsDataURL(e.target.files[0]);
        } else {
            setRegisterDetails({ ...registerDetails, [e.target.name]: e.target.value });
        }
    };

    return loading ? (
        <Loader />
    ) : (
        <div className='loginScreen'>
            <Container>
                <div className='formContainer'>
                    <div className='formContentSection'>
                        <div
                            className={`loginRegisterTab ${
                                activeTab === 'LOGIN' ? 'loginActive' : ''
                            }`}
                        >
                            <button onClick={() => setActiveTab('LOGIN')}>Login</button>
                            <button onClick={() => setActiveTab('REGISTER')}>Register</button>
                        </div>
                        <div className='loginRegisterForm'>
                            {activeTab === 'LOGIN' ? (
                                <form onSubmit={handleLoginSubmit}>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineMail />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Email'
                                            aria-label='Email'
                                            aria-describedby='basic-addon1'
                                            name='email'
                                            value={loginDetails.email}
                                            onChange={handleLoginDataChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineUnlock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Password'
                                            aria-label='Password'
                                            type='Password'
                                            aria-describedby='basic-addon1'
                                            name='password'
                                            value={loginDetails.password}
                                            onChange={handleLoginDataChange}
                                        />
                                    </InputGroup>
                                    <Link
                                        className='text-grey text-center font-size-14 text-decoration-underline mb-3 d-block'
                                        to='/password/forgot'
                                    >
                                        Forgot Password?
                                    </Link>
                                    <input type='submit' value='Sign In' className='submitBtn' />
                                </form>
                            ) : (
                                <form onSubmit={handleRegisterSubmit}>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineUser />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Name'
                                            aria-label='Name'
                                            name='name'
                                            value={registerDetails.name}
                                            onChange={handleRegisterDataChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineMail />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Email'
                                            aria-label='Email'
                                            name='email'
                                            value={registerDetails.email}
                                            onChange={handleRegisterDataChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineUnlock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Password'
                                            aria-label='Password'
                                            name='password'
                                            type='password'
                                            value={registerDetails.password}
                                            onChange={handleRegisterDataChange}
                                        />
                                    </InputGroup>
                                    <div className='registerImg'>
                                        <div className='register-img-circle'>
                                            <img src={avatarPreview} alt='Avatar Preview' />
                                        </div>
                                        <input
                                            type='file'
                                            name='avatar'
                                            accept='image/'
                                            onChange={handleRegisterDataChange}
                                        />
                                    </div>
                                    <input type='submit' value='Sign Up' className='submitBtn' />
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default RegisterLogin;
